<!-- <footer class="scc-footer">
  <div class="footer-container">
    <div class="footer-top">
      <div class="footer-contact">
        <a href="https://www.surreycc.gov.uk/council-and-democracy/contact-us"><i class="fas fa-phone"></i> Contact</a>
        <a href="https://www.surreycc.gov.uk/council-and-democracy/offices"><i class="fas fa-map-marker-alt"></i> Offices</a>
      </div>

      <div class="footer-social">
        <a href="https://twitter.com/SurreyNews"><i class="fab fa-x-twitter"></i></a>
        <a href="https://www.facebook.com/Surrey-County-Council-126261804063269/"><i class="fab fa-facebook-f"></i></a>
        <a href="https://www.youtube.com/user/SurreyCountyCouncil"><i class="fab fa-youtube"></i></a>
        <a href="https://www.instagram.com/surreycountycouncil/"><i class="fab fa-instagram"></i></a>
        <a href="https://www.linkedin.com/company/surrey-county-council/careers?trk=top_nav_careers"><i class="fab fa-linkedin-in"></i></a>
      </div>
    </div>
    <div class="footer-links">
      <a href="https://www.surreycc.gov.uk/website/disclaimer">Disclaimer</a>
      <a href="https://www.surreycc.gov.uk/council-and-democracy/your-privacy">Your privacy</a>
      <a href="https://www.surreycc.gov.uk/website/cookies">Cookies</a>
      <a href="https://www.surreycc.gov.uk/website/accessibility">Accessibility</a>
      <a href="https://www.surreycc.gov.uk/website">About our website</a>
      <a href="https://www.surreycc.gov.uk/council-and-democracy/how-the-council-works/council-policies-and-strategies/modern-slavery-statement">Modern slavery statements</a>
      <a href="https://www.surreycc.gov.uk/site-map">Site map</a>
    </div>
    <div class="footer-bottom">
      <a href="#">Home</a>
      <span>© Surrey County Council 2025</span>
      <span>ID: 1155</span>
    </div>

  </div>
</footer> -->


<footer class="scc-footer">
  <div class="footer-container">
    <div class="footer-row">
      <div class="footer-col-left">
        <div class="footer-contact">
          <a href="#">
            <img src="https://www.surreycc.gov.uk/__data/assets/image/0008/54728/Call-Icon-white-19x30.png" alt="Contact Icon" style="height: 30x;"> Contact
          </a>
          <a href="#">
            <img src="https://www.surreycc.gov.uk/__data/assets/image/0009/54729/Map-Icon-white-24x30.png" alt="Office Icon" style="height: 30px;"> Offices
          </a>
        </div>
        <div class="footer-social">
          <a href="https://twitter.com/SurreyNews" aria-label="Follow us on Twitter"><i class="fab fa-x-twitter"></i><span class="sr-only">Twitter</span></a>
          <a href="https://www.facebook.com/Surrey-County-Council-126261804063269/"><i class="fa-brands fa-facebook"></i><span class="sr-only">Facebook</span></a>
          <a href="https://www.youtube.com/user/SurreyCountyCouncil"><i class="fa-brands fa-youtube"></i><span class="sr-only">YouTube</span></a>
          <a href="https://www.instagram.com/surreycountycouncil/"><i class="fa-brands fa-instagram"></i><span class="sr-only">Instagram</span></a>
          <a href="https://www.linkedin.com/company/surrey-county-council/careers?trk=top_nav_careers"><i class="fa-brands fa-linkedin"></i><span class="sr-only">LinkedIn</span></a>
        </div>

        <div class="footer-under-icons inline">
          <a href="https://www.surreycc.gov.uk/">Home</a>
          <span>© Surrey County Council 2025</span>
          <span>ID: 94</span>
        </div>
      </div>

      <div class="footer-col-right">
        <div class="footer-links footer-links-top">
          <a href="https://www.surreycc.gov.uk/website/disclaimer">Disclaimer</a>
          <a href="https://www.surreycc.gov.uk/council-and-democracy/your-privacy">Your privacy</a>
          <a href="https://www.surreycc.gov.uk/website/cookies">Cookies</a>
          <a href="https://www.surreycc.gov.uk/website/accessibility">Accessibility</a>
        </div>
        <div class="footer-links footer-links-bottom">
          <a href="https://www.surreycc.gov.uk/website">About our website</a>
          <a href="https://www.surreycc.gov.uk/council-and-democracy/how-the-council-works/council-policies-and-strategies/modern-slavery-statement">Modern slavery statements</a>
          <a href="https://www.surreycc.gov.uk/site-map">Site map</a>
        </div>
      </div>
    </div>

    <button class="scc-top-link" title="Return to top">
      <span class="sr-only">Top</span>
    </button>
  </div>
</footer>


